import Layout from "../../Frames/Layout"
import Emails from "../../../services/API/Emails"
import { useState, useEffect } from "react"
import { TextField, Stack, Button } from "@mui/material"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Toast from "../../Tools/Toast"
import {LoadingButton} from '@mui/lab'
import { useParams, Link } from "react-router-dom"
import Tip from "../../Tools/Tip"
import Loader from "../../Tools/Loader";

export default function Form(){

    const {id} = useParams()
    const [item, setItem] = useState(null);
    const [toast, setToast] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [changed, setChanged] = useState(false);


    useEffect(() => {

        Emails.get(id)
            .then(r => setItem(r.data))
            .catch(e => setToast(['error', "L'email n'a pas été trouvé."]))

    }, [id])

    const handleChange = data => {
        let copy = {...item};
        Object.assign(copy, data);
        setChanged(true);
        return setItem(copy);
    }


    const handleSubmit = e => {
        e.preventDefault();
        
        Emails.put(item)
            .then(() => handleSuccess())
            .catch(() => handleError())

        return setSubmitting(true);
    }


    const handleSuccess = () => {
        setSubmitting(false);
        return setChanged(false);
    }


    const handleError = () => {
        setToast(['error', "Une erreur s'est produite, vos modifications n'ont pas pu être enregistrées"]);
        return setSubmitting(false);
    }


    const handleTest = () => {

        const recipient = window.prompt('Adresse email de test :', window.localStorage.getItem('email_test') || '');

        if(!recipient) return false;

        window.localStorage.setItem('email_test', recipient);

        Emails.test(id, recipient)
            .then(r => setToast(['success', "L'email a bien été envoyé"]))
            .catch(e => setToast(['error', "L'email n'a pas pu être envoyé"]))

        return false;
    }

    return <Layout title="Emails" tab="emails" menu="marketing">

        <Stack direction='row' justifyContent='center' sx={{mb: 2}}>
        
            {item && <form onSubmit={handleSubmit}>

                <Stack direction='column' width={formWidth} spacing={3}>

                    <Stack direction='row' justifyContent='end'>
                        <Link to={`/marketing/emails`}>
                            <Tip type='close'/>
                        </Link>
                    </Stack>

                    <TextField
                        label="Objet de l'email"
                        value={item.subject}
                        onChange={e => handleChange({...item, subject: e.target.value})}
                        size='small'
                        required
                    />

                    <ReactQuill 
                        value={item.body} 
                        onChange={html => handleChange({...item, body: html})}
                    />

                    <Stack direction='row' spacing={2} justifyContent='end'>

                        {!changed && <Button 
                            variant='outlined' 
                            onClick={handleTest}
                        >
                            Tester
                        </Button>}

                        {changed && <LoadingButton 
                            variant='contained' 
                            type='submit' 
                            loading={submitting}
                        >
                            Enregistrer
                        </LoadingButton>}

                    </Stack>

                    <p><b>Variables disponibles :</b></p>

                    <ul>
                        {item.variables.map(v => 
                            <li key={v.id}>{'{' + v.id + '}'} = {v.title}</li>    
                        )}
                    </ul>

                
                </Stack>

            </form>}

        </Stack>


        {!item && <Loader />}


        <Toast
            open={toast ? true : false} 
            severity={toast[0]} 
            duration={5000} 
            onClose={() => setToast(false)}
            message={toast[1]}
        />

    </Layout>
}

const formWidth = window.screen.width < 800 ? 350 : 600;